import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
	Box,
	Button,
	// Box,
	Container,
	Link,
	// Link,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';

import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import theme from '../../../assets/theme/theme';
import ScrollToTop from '../../../components/layout/ScrollToTop';
import { PAGES_URLS } from '../../../lib/constants/routes';

const Datenschutz: FC<{}> = () => {
	const navigate = useNavigate();

	return (
		<>
			<ScrollToTop />
			<Container>
				<Button
					variant='outlined'
					startIcon={<ArrowBackIcon />}
					sx={{ margin: '0 auto 3rem auto', boxShadow: 'none' }}
					onClick={() => navigate(PAGES_URLS.Startseite)}
				>
					Zurück Zur Startseite
				</Button>
				<Stack spacing={2}>
					<Box>
						<Typography variant='h2' component='h1' sx={{ fontWeight: 600, paddingBottom: '1rem' }}>
							Ihre Rechte
						</Typography>
					</Box>

					<Box sx={{ marginBottom: '2rem' }}>
						<Typography>
							Gemäß Artikel 13 der Datenschutz-Grundverordnung (DSGVO) informieren wir Sie im Folgenden über die Erhebung personenbezogener Daten bei
							der Nutzung unseres Stipendienportals und Ihre Rechte.
						</Typography>
					</Box>

					<Box>
						<Typography sx={{ fontWeight: 500 }}>Verantwortliche(r) ist gemäß Art. 4 Abs. 7 der DSGVO die</Typography>
					</Box>

					<Box>
						<Typography>Akademie der Künste</Typography>
						<Typography>vertreten durch Herrn Prof. Manos Tsangaris</Typography>
						<Typography>Hanseatenweg 10</Typography>
						<Typography>10557 Berlin</Typography>
						<Typography>
							<Link href='mailto:info@adk.de'>info@adk.de</Link>
						</Typography>
					</Box>

					<Box>
						<Typography>
							Unseren externen Datenschutzbeauftragten erreichen Sie unter <Link href='mailto:datenschutz@adk.de'>datenschutz@adk.de</Link> oder unter
							der Postadresse:
						</Typography>
					</Box>

					<Box>
						<Typography>Akademie der Künste</Typography>
						<Typography>Datenschutzbeauftragte</Typography>
						<Typography>Hanseatenweg 10</Typography>
						<Typography>10557 Berlin</Typography>
					</Box>

					<Box>
						<Typography>
							Personenbezogene Daten sind alle Angaben, die auf Sie persönlich beziehbar sind, z. B. Name, Adresse, Telefonnummer und E-Mail-Adressen.
							Bei Ihrer Kontaktaufnahme mit uns per E-Mail oder über ein Kontaktformular werden die von Ihnen mitgeteilten Angaben von uns
							gespeichert, um Ihre Fragen zu beantworten oder Ihnen gewünschtes Material zur Verfügung stellen zu können. Die Einwilligung dazu muss
							für die jeweilige konkrete Anwendung erteilt werden.
						</Typography>
					</Box>

					<Box>
						<Typography>
							Die in diesem Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich ist, oder schränken die
							Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen.
						</Typography>
					</Box>

					<Box>
						<Typography>
							Falls wir für einzelne Funktionen unseres Angebots auf beauftragte Dienstleister zurückgreifen, werden wir Sie über die jeweiligen
							Vorgänge und die Speicherfristen informieren. Ansonsten geben wir Ihre Daten nicht an Dritte weiter.
						</Typography>
					</Box>

					<Box>
						<Typography>Sie haben uns gegenüber in Bezug auf Ihre Daten:</Typography>
						<ul>
							<li>
								<Typography>das Recht auf Auskunft,</Typography>
							</li>
							<li>
								<Typography>das Recht auf Berichtigung oder Löschung,</Typography>
							</li>
							<li>
								<Typography>das Recht auf Einschränkung der Verarbeitung,</Typography>
							</li>
							<li>
								<Typography>das Recht auf Widerspruch gegen die Verarbeitung und</Typography>
							</li>
							<li>
								<Typography>das Recht auf Datenübertragbarkeit (Erhalt einer Kopie Ihrer Daten).</Typography>
							</li>
						</ul>
					</Box>
					<Box>
						<Typography marginTop={'-1rem'}>
							Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu
							beschweren. Die Aufsichtsbehörde im Sinne von § 19 des Bundesdatenschutzgesetzes (BDSG) ist die Bundesbeauftragte für den Datenschutz
							und die Informationsfreiheit.
						</Typography>
					</Box>

					<Stack
						sx={{
							'& li': {
								padding: '4px 0',
							},
							'& li > *': {
								paddingLeft: '3px',
							},
						}}
					>
						<Typography variant='h6' component='h2'>
							<strong>Erhebung personenbezogener Daten zur Teilnahme am Vergabeverfahren des</strong> Alfred-Döblin-Stipendiums
						</Typography>
						{/* Liste Teil 1 */}
						<Box component='ol'>
							<li>
								<Typography component='span'>
									Zwecke, für die die personenbezogenen Daten verarbeitet werden sollen: Durchführung des Bewerbungsprozesses, Entscheidung über die
									Vergabe eines Stipendiums.
								</Typography>
							</li>
							<li>
								<Typography component='span'>Welche Ihrer Daten erheben wir und wozu verarbeiten wir sie?</Typography>
							</li>
						</Box>

						{/* Tabelle kann hier stehen */}

						<Box sx={{ p: { xs: '0', md: '0 42px' }, margin: '-1rem 0', width: '100%', overflow: 'auto' }}>
							<TableContainer sx={{ overflowX: 'auto', width: '100%' }}>
								<Table
									sx={{
										border: '1px solid rgba(224, 224, 224, 1)',
										tableLayout: 'auto',

										'& .MuiTableCell-head': {
											borderRight: '1px solid rgba(224, 224, 224, 1)', // dunkler wie im Bild
											fontWeight: 'bold',
											backgroundColor: theme.palette.background.paper, // wie im Bild
										},
										'& .MuiTableCell-body': {
											borderRight: '1px solid rgba(224, 224, 224, 1)', // wie vorher
										},
									}}
								>
									<TableHead>
										<TableRow>
											<TableCell>
												<strong>Datum</strong>
											</TableCell>
											<TableCell>
												<strong>Pflichtangabe</strong>
											</TableCell>
											<TableCell>
												<strong>Zweck der Erhebung</strong>
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{/* Abschnitt: Ihre Personendaten */}
										<TableRow
											sx={{
												borderBottom: '1px solid rgba(224, 224, 224, 1)',
												'& td': {
													borderRight: 'none !important',
												},
											}}
										>
											<TableCell>
												<strong>Personendaten</strong>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Titel</TableCell>
											<TableCell>nein</TableCell>
											<TableCell>
												1. Durchführung von Korrespondenz mit Ihnen (Anrede)
												<br />
												2. Auswertungen mit Bezug zur Geschlechtergerechtigkeit
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Geschlecht (divers, keine Angabe, männlich, weiblich)</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>
												1. Durchführung von Korrespondenz mit Ihnen (Anrede)
												<br />
												2. Auswertungen mit Bezug zur Geschlechtergerechtigkeit
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Vorname, Nachname</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>
												3. Anlage eines Benutzerkontos
												<br />
												4. Durchführung von Korrespondenz mit Ihnen
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Geburtsdatum</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>
												1. Auswertungen im Hinblick auf die Verteilung bewerbender Personen und zuerkannter Stipendienplätze auf die Altersverteilung
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Staatsbürgerschaft</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>
												2. Auswertungen im Hinblick auf die Verteilung bewerbender Personen und zuerkannter Stipendienplätze auf das Land
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>E-Mail</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>
												1. Anlage eines Benutzerkontos
												<br />
												2. Durchführung von E-Mail-Korrespondenz mit Ihnen
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Telefon</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>1. Durchführung von Kommunikation mit Ihnen</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Straße und Hausnummer</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>1. Durchführung von Korrespondenz mit Ihnen</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>PLZ</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>1. Durchführung von Korrespondenz mit Ihnen</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Ort</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>2. Durchführung von Korrespondenz mit Ihnen</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Bundesland</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>3. Durchführung von Korrespondenz mit Ihnen</TableCell>
										</TableRow>

										{/* Abschnitt: Ihre Zugangsdaten */}
										<TableRow
											sx={{
												borderBottom: '1px solid rgba(224, 224, 224, 1)',
												'& td': {
													borderRight: 'none !important',
												},
											}}
										>
											<TableCell>
												<strong>Ihre Zugangsdaten</strong>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>E-Mail-Adresse (vorausgefüllt)</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>1. Anlage eines Benutzerkontos</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Benutzername</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>2. Anlage eines Benutzerkontos</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Passwort</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>3. Anlage eines Benutzerkontos</TableCell>
										</TableRow>

										{/* Abschnitt: Bewerbungsdaten */}
										<TableRow
											sx={{
												borderBottom: '1px solid rgba(224, 224, 224, 1)',
												'& td': {
													borderRight: 'none !important',
												},
											}}
										>
											<TableCell>
												<strong>Bewerbungsdaten</strong>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Arbeitstitel Manuskript</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>4. Erkenntnisquelle zur Beurteilung durch die Jury-Entscheidung</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Gattungsbezeichnung</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>1. Erkenntnisquelle zur Beurteilung durch die Jury-Entscheidung</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Wunschzeitraum für Stipendium von/bis</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>5. Erkenntnisquelle zur Beurteilung durch die Jury-Entscheidung</TableCell>
										</TableRow>

										{/* Antragstellerin */}
										<TableRow
											sx={{
												borderBottom: '1px solid rgba(224, 224, 224, 1)',
												'& td': {
													borderRight: 'none !important',
												},
											}}
										>
											<TableCell>
												<strong> Antragstellerin</strong>
											</TableCell>
										</TableRow>
										<TableRow
											sx={{
												borderBottom: '1px solid rgba(224, 224, 224, 1)',
												'& td': {
													borderRight: 'none !important',
												},
											}}
										>
											<TableCell>
												<em>wie Personendaten</em>
											</TableCell>
										</TableRow>
										{/* Abschnitt: Bankdaten */}
										<TableRow
											sx={{
												borderBottom: '1px solid rgba(224, 224, 224, 1)',
												'& td': {
													borderRight: 'none !important',
												},
											}}
										>
											<TableCell>
												<strong>Bankdaten</strong>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Kontoinhaber</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>6. Zahlungsabwicklung im Fall der Stipendienzuteilung</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Institut/IBAN/BIC</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>7. Zahlungsabwicklung im Fall der Stipendienzuteilung</TableCell>
										</TableRow>

										{/* Weitere Bewerbungsdaten */}
										<TableRow
											sx={{
												borderBottom: '1px solid rgba(224, 224, 224, 1)',
												'& td': {
													borderRight: 'none !important',
												},
											}}
										>
											<TableCell>
												<strong>Bewerbungsdaten</strong>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Seit wann sind Sie schriftstellerisch tätig?</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>8. Erkenntnisquelle zur Beurteilung durch die Jury-Entscheidung</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>Bisherige Veröffentlichungen</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>9. Erkenntnisquelle zur Beurteilung durch die Jury-Entscheidung</TableCell>
										</TableRow>
										<TableRow>
											<TableCell>
												Anlagen (Arbeitsproben, Dokumente, Auszüge aus aktuellem Manuskript, Empfehlungsschreiben, künstlerischer Lebenslauf, Exposé)
											</TableCell>
											<TableCell>ja</TableCell>
											<TableCell>1. Erkenntnisquelle zur Beurteilung durch die Jury-Entscheidung</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</Box>
						<Box component='ol' start={3}>
							<li>
								<Typography component='span'>Rechtsgrundlage für die Verarbeitung: Art. 6 Abs. 1 Buchstabe a DSGVO</Typography>
							</li>
							<li>
								<Typography component='span'>
									Empfänger oder Kategorien von Empfängern der personenbezogenen Daten: Mitarbeitende der Sektion Literatur der Akademie der Künste,
									Mitglieder der Jury, die Bereiche IT und Finanzen, die Geschäftsführung und der Senat. Eine Übermittlung an Dritte erfolgt nicht,
									mit Ausnahme unserer Dienstleister im Rahmen der Auftragsverarbeitung.
								</Typography>
							</li>
						</Box>

						<Typography>
							Unser Dienstleister im Rahmen des Vergabeverfahrens ist die <strong>B&amp;IT Services GmbH.</strong>
						</Typography>

						<Box component='ol' start={5}>
							<li>
								<Typography component='span'>
									Eine Absicht, die personenbezogenen Daten an ein Drittland oder eine internationale Organisation zu übermitteln, besteht nicht.
								</Typography>
							</li>
							<li>
								<Typography component='span'>
									Dauer, für die die personenbezogenen Daten gespeichert werden oder, falls dies nicht möglich ist, die Kriterien für die Festlegung
									dieser Dauer: Die Daten werden 6 Monate nach Abschluss des Bewerbungsverfahrens gelöscht. Wird ein Stipendium an Sie vergeben,
									informieren wir Sie gesondert über die Nutzung der Daten im Rahmen Alfred-Döblin-Stipendiums.
								</Typography>
							</li>
							<li>
								<Typography component='span'>
									Die Bereitstellung der personenbezogenen Daten ist nicht gesetzlich oder vertraglich vorgeschrieben. Jedoch ist die Angabe
									personenbezogener Daten für die Vergabe eines Stipendiums erforderlich. Sie sind nicht verpflichtet, die personenbezogenen Daten
									bereitzustellen. Folge einer Nichtbereitstellung wäre, dass wir Sie nicht im Vergabeverfahren berücksichtigen können.
								</Typography>
							</li>
							<li>
								<Typography component='span'>
									Eine <strong>automatisierte Entscheidungsfindung</strong> erfolgt <strong>nicht</strong>.
								</Typography>
							</li>
						</Box>
					</Stack>
				</Stack>
			</Container>
		</>
	);
};
export default Datenschutz;
